const categoryPatterns = [
  { id: "frames", pattern: /frame|gallery|float/i },
  { id: "toploaders", pattern: /top\s*load|card\s*saver/i },
  { id: "cases", pattern: /case|cube|display/i },
  { id: "funko", pattern: /funko|pop.*(vault|protector)/i },
  { id: "stands", pattern: /stand|easel|block/i },
  { id: "archival", pattern: /archival|sleeve|mylar/i },
];

const categoryLabels = {
  frames: "Frames",
  toploaders: "Top Loaders",
  cases: "Display Cases",
  funko: "Funko Protectors",
  stands: "Stands",
  archival: "Archival",
};

export function categorizeProduct(product) {
  const text = `${product.product_type || ""} ${product.name || ""}`;
  for (const { id, pattern } of categoryPatterns) {
    if (pattern.test(text)) return id;
  }
  return null;
}

export function buildAccessoryCategories(products) {
  const counts = {};
  for (const p of products) {
    const cat = categorizeProduct(p);
    if (cat) {
      counts[cat] = (counts[cat] || 0) + 1;
    }
  }

  const categories = [
    { id: "all", label: "All Accessories", count: products.length },
  ];

  for (const { id } of categoryPatterns) {
    if (counts[id]) {
      categories.push({
        id,
        label: categoryLabels[id],
        count: counts[id],
      });
    }
  }

  return categories;
}

export function sortProducts(products, sortBy) {
  const sorted = [...products];
  switch (sortBy) {
    case "priceAsc":
      return sorted.sort((a, b) => (a._totalPrice || 0) - (b._totalPrice || 0));
    case "priceDesc":
      return sorted.sort((a, b) => (b._totalPrice || 0) - (a._totalPrice || 0));
    case "newest":
      return sorted.sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0),
      );
    case "curated":
    default:
      return sorted;
  }
}
